import {Directive, HostListener, inject} from '@angular/core';
import {SOURCE_CHIP_CLASS} from '../models/report/report-source-links';
import {PopoutContentService} from '../services/popout/popout.service';

/**
 * Öffnet die Quellen-Badges eines KI-Antworttexts in einem neuen Tab.
 *
 * Die Badges entstehen als Anker im Markdown (siehe `linkifySourceFiles`) und sind deshalb keine
 * Angular-Elemente – ein `routerLink` oder `(click)` je Badge ist dort nicht möglich. Die Direktive
 * sitzt stattdessen auf dem umgebenden Container und fängt den Klick per Delegation ab; damit steht
 * die Logik nur einmal da und gilt für beide Berichtsansichten.
 */
@Directive({
  selector: '[appReportSourceLinks]',
})
export class ReportSourceLinkDirective {
  private popoutService = inject(PopoutContentService);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const anchor = target?.closest<HTMLAnchorElement>(`a.${SOURCE_CHIP_CLASS}`);
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    // Nicht nur das Navigieren verhindern: Zeile bzw. Karte um den Text herum sind selbst
    // klickbar (Auswahl/Aufklappen) und würden sonst mitschalten.
    event.preventDefault();
    event.stopPropagation();
    this.popoutService.open(href, anchor.title, true);
  }
}
